import { render, staticRenderFns } from "./CalendarTab.vue?vue&type=template&id=852fccc6&scoped=true&lang=pug"
import script from "./CalendarTab.vue?vue&type=script&lang=ts"
export * from "./CalendarTab.vue?vue&type=script&lang=ts"
import style0 from "./CalendarTab.vue?vue&type=style&index=0&id=852fccc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852fccc6",
  null
  
)

export default component.exports